import React, {useEffect, useState} from "react"
import {Button, Modal, Tree} from "antd"
import CustomButton from "../../components/CustomButton"
import {useTranslation} from "react-i18next"
import {useSelector} from "react-redux"
import api from "./store/api";
import LocalLoading from "../../components/Loading/Local";

const PriceTree = (props) => {
    const {visible, setVisible, object, setProject} = props
    const [checkedPtms, setCheckedPtms] = useState([]);
    const [ptmInfo, setPtmInfo] = useState({visible: false, record: null});
    const [state, setState] = useState(null)
    const {isLoading: isSending, ptms} = useSelector((state) => state.rePtmReducer)
    const {t} = useTranslation(['common', 'valid', 'action'])
    //const dispatch = useDispatch()

    useEffect(() => {
        if (ptms.length === 0) {
            //dispatch(ptmActions.getPtmSecondLevel())
        }
        if (object) {
            getPricesById(object.id)
        }
    }, [object])

    const onChange = (page, pageSize) => {
        getPricesById(page, pageSize)
    };

    function getPricesById() {
        api.getAllPriceByObjectId({Id: object.id})
            .then(r => {
                let res = r.map((el, idx) => ({key: idx, ...el}))
                setState(res)
            })
    };

    function handleCancel() {
        setVisible(false)
        setState(null)
    }

    function handleDescriptionCancel() {
        setPtmInfo({visible: false, record: null})
    }

    function save() {
        setVisible(false)
        setProject([...checkedPtms])
    }

    const onSelect = (selectedKeys, info) => {
        let prices = state.map(m => m.smetas)[0].map(s => s.prices).reduce(function(a, b){ return a.concat(b); }, []);
        let record = prices.find(r => r.id === selectedKeys[0])
        if (record?.id > 0) {
            setPtmInfo({visible: true, record: record})
        }
    }

    const onCheck = (checkedKeys, info) => {
        let checked = state.filter(r => checkedKeys.includes(r.key))
        setCheckedPtms(checked)
    }

    let treeData = state?.map(item => {
        return {
            key: item.number,
            title: `${item.name} (${item.price})`,
            /*disableCheckbox: item.id === 0,*/
            children: item.smetas
                .map((el) => ({
                    key: el.id,
                    title: `${el.name} (${el.price})`,
                    /*disableCheckbox: el.id === 0,*/
                    children: el.prices
                        .map(m => ({
                            key: m.id,
                            title: m.ptmDescription,
                            /*disableCheckbox: m.id === 0,*/
                        }))
                }))
        }
    })

    //let treeData = state
    return (
        <>
            <Modal
                destroyOnHidden
                footer={[
                    /*<CustomButton
                        key="save"
                        //loading={isSending}
                        type="green"
                        onClick={save}
                    >
                        {t('action:fixSelection')}
                    </CustomButton>*/
                ]}
                title={`Сметы для ${object?.name}`}
                open={visible}
                width={900}
                onCancel={handleCancel}
            >
                {isSending
                    ? <LocalLoading/>
                    : <Tree
                        //checkable
                        className='custom-select'
                        treeData={treeData}
                        onSelect={onSelect}
                        onCheck={onCheck}
                        defaultExpandedKeys={['1']}
                    />
                }
            </Modal>
            {ptmInfo.record &&
                <Modal
                    title={`ПТМ`}
                    open={ptmInfo.visible}
                    destroyOnHidden
                    onCancel={handleDescriptionCancel}
                    footer={[
                        <Button
                            key="save"
                            //loading={isSending}
                            onClick={handleDescriptionCancel}
                        >
                            Ok
                        </Button>
                    ]}
                >
                    {/*<p>{`Код ПТМ: ${ptm.record.code}`}</p>*/}
                    {/*<p>{`Название: ${ptmInfo.record.name}`}</p>*/}
                    <p>{`Описание: ${ptmInfo.record.ptmDescription}`}</p>
                    <p>{`Объем ПТМ: ${ptmInfo.record.volume}`}</p>
                    {/*<p>{`Единица измерения: ${ptm.record.reMeasurementUnitName}`}</p>*/}
                    <p>{`Заработная плата: ${ptmInfo.record.pay}`}</p>
                    <p>{`Трудоемкость: ${ptmInfo.record.lc}`}</p>
                    <p>{`Эксплуатация машин: ${ptmInfo.record.omach}`}</p>
                    <p>{`В том числе заработная плата рабочего(эксплуатация машин): ${ptmInfo.record.iPay}`}</p>
                    <p>{`Материалы: ${ptmInfo.record.matt}`}</p>
                    <p>{`Транспорт (материалы): ${ptmInfo.record.trm}`}</p>
                    <p>{`Оборудование: ${ptmInfo.record.eqp}`}</p>
                    <p>{`Транспорт (оборудования): ${ptmInfo.record.tre}`}</p>
                    <p>{`ОХР и ОПР: ${ptmInfo.record.oo}`}</p>
                    <p>{`Плановая прибыль: ${ptmInfo.record.pp}`}</p>
                    <p>{`Прочие затраты: ${ptmInfo.record.oc}`}</p>
                </Modal>
            }
        </>
    )
}
export default PriceTree
